"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFunction = isFunction;
exports.isObject = isObject;
exports.isArray = isArray;
exports.isError = isError;
exports.isObjectEmpty = isObjectEmpty;
exports.lowerObjectKeys = lowerObjectKeys;
exports.mergeDictionaries = mergeDictionaries;
exports.toDictionary = toDictionary;
exports.serialize = serialize;
exports.truncate = truncate;
var string_1 = require("./string");
var dateTime_1 = require("./dateTime");
function isFunction(functionToCheck) {
    var getType = {};
    return (functionToCheck &&
        getType.toString.call(functionToCheck) === "[object Function]");
}
function isObject(argAsString) {
    return /^\[object\s.*\]$/.test(argAsString);
}
function isArray(obj) {
    if (typeof Array.isArray === "undefined")
        return Object.prototype.toString.call(obj) === "[object Array]";
    return Array.isArray(obj);
}
function isError(arg) {
    return arg instanceof Error;
}
function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function lowerObjectKeys(dict) {
    var lowerCaseKeysDict = {};
    for (var key in dict) {
        if (dict.hasOwnProperty(key)) {
            lowerCaseKeysDict[key.toLowerCase()] = dict[key];
        }
    }
    return lowerCaseKeysDict;
}
function mergeDictionaries(obj, src, replaceIfEmpty) {
    for (var key in src) {
        if (src.hasOwnProperty(key)) {
            if (!src[key] && !replaceIfEmpty)
                continue;
            obj[key] = src[key];
        }
    }
    return obj;
}
function toDictionary(items, keySelector, valueSelector) {
    var obj = {};
    items.forEach(function (i) { return (obj[keySelector(i)] = valueSelector(i)); });
    return obj;
}
function serialize(value, deep, primitiveMaxLength, arrayMaxLength) {
    var valueAsString = serializePrimitive(value, primitiveMaxLength);
    if (isArray(value))
        valueAsString = serializeArray(value, deep, primitiveMaxLength, arrayMaxLength);
    if (isObject(valueAsString))
        valueAsString = serializeObject(value, deep, primitiveMaxLength, arrayMaxLength);
    if (isError(value))
        valueAsString = serializeError(value, primitiveMaxLength, arrayMaxLength);
    return valueAsString;
}
function truncate(value, deep) {
    if (isError(value))
        return value;
    var truncated = truncatePrimitive(value);
    if (isArray(value))
        truncated = truncateArray(truncated, deep);
    if (isObject(serializePrimitive(value)))
        truncated = truncateObject(truncated, deep);
    return truncated;
}
function serializePrimitive(value, primitiveMaxLength) {
    var propAsString = "";
    if (value === null)
        propAsString = "null";
    else if (value === undefined)
        propAsString = "undefined";
    else if (value instanceof Date)
        propAsString = (0, dateTime_1.formatDate)(value, "yyyy-MM-dd'T'HH:mm:ss");
    else if (typeof value === "string") {
        propAsString = "'" + (0, string_1.preview)(value, primitiveMaxLength) + "'";
    }
    else if (isFunction(value) || value instanceof Promise) {
        propAsString = "";
    }
    else if (value.toString) {
        var strProp = value.toString();
        propAsString = isArray(value) ? "[" + strProp + "]" : strProp;
    }
    return propAsString;
}
function truncatePrimitive(value) {
    if (typeof value === "string") {
        return (0, string_1.preview)(value);
    }
    else if (isFunction(value) || value instanceof Promise) {
        return "__some_function_or_a_promise__";
    }
    return value;
}
function serializeArray(array, deep, primitiveMaxLength, arrayMaxLength) {
    var _arrayMaxLength = arrayMaxLength || 5;
    var serialized = "[";
    if (array.length === 0) {
        serialized += "]";
    }
    else if (array.length <= _arrayMaxLength) {
        array.forEach(function (elem) {
            return (serialized +=
                serialize(elem, deep - 1, primitiveMaxLength, arrayMaxLength) + ",");
        });
        serialized = serialized.replace(/,\s*$/, "");
        serialized += "]";
    }
    else {
        var firstAsString = serialize(array[0], deep - 1, primitiveMaxLength, arrayMaxLength);
        serialized += "0: ".concat(firstAsString);
        if (array.length > 1) {
            var lastAsString = serialize(array[array.length - 1], deep - 1, primitiveMaxLength, arrayMaxLength);
            serialized += "  ...  ".concat(array.length - 1, ": ").concat(lastAsString);
        }
        serialized += "]";
    }
    return serialized;
}
function truncateArray(array, deep) {
    if (array.length <= 5)
        return array.map(function (elem) { return truncate(elem, deep - 1); });
    return {
        type: "__big_array__",
        length: array.length,
        first: truncate(array[0], deep - 1),
        last: truncate(array[array.length - 1], deep - 1),
    };
}
function serializeObject(obj, deep, primitiveMaxLength, arrayMaxLength) {
    var serialized = "{";
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            var propValue = void 0;
            // In some cases accessing property can cause exceptions. Example:
            // "DOMException: Failed to read the 'responseText' property from 'XMLHttpRequest':
            // The value is only accessible if the object's 'responseType' is '' or 'text' (was 'arraybuffer')."
            try {
                propValue = obj[prop];
            }
            catch (e) {
                propValue = "__inaccessible_prop_value__";
            }
            var propAsString = serializePrimitive(propValue, primitiveMaxLength);
            if (propAsString === "")
                continue;
            if ((isObject(propAsString) && !deep) || deep < 0)
                continue;
            if (serialized.length > 1)
                serialized += ",";
            if (isArray(propValue)) {
                serialized +=
                    prop +
                        ":" +
                        serializeArray(propValue, deep - 1, primitiveMaxLength, arrayMaxLength);
            }
            else if (isObject(propAsString)) {
                var childSerialized = serializeObject(propValue, deep - 1, primitiveMaxLength, arrayMaxLength);
                if (childSerialized.length > 2) {
                    serialized +=
                        prop +
                            ":" +
                            serializeObject(propValue, deep - 1, primitiveMaxLength, arrayMaxLength);
                }
            }
            else {
                serialized += prop + ":" + propAsString;
            }
        }
    }
    return serialized + "}";
}
function truncateObject(obj, deep) {
    var truncated = {};
    for (var propName in obj) {
        if (obj.hasOwnProperty(propName)) {
            var propValue = void 0;
            // In some cases accessing property can cause exceptions. Example:
            // "DOMException: Failed to read the 'responseText' property from 'XMLHttpRequest':
            // The value is only accessible if the object's 'responseType' is '' or 'text' (was 'arraybuffer')."
            try {
                propValue = obj[propName];
            }
            catch (e) {
                propValue = "__inaccessible_prop_value__";
            }
            var truncatedPrimitive = truncatePrimitive(propValue);
            if (truncatedPrimitive === "")
                continue;
            if ((isObject(truncatedPrimitive) && !deep) || deep < 0)
                continue;
            if (isArray(propValue)) {
                truncated[propName] = truncateArray(propValue, deep - 1);
            }
            else if (isObject(truncatedPrimitive)) {
                truncated[propName] = truncateObject(propValue, deep - 1);
            }
            else {
                truncated[propName] = truncatedPrimitive;
            }
        }
    }
    return truncated;
}
function serializeError(error, primitiveMaxLength, arrayMaxLength) {
    return "".concat(error.message, "; request info: ").concat(serializeObject(error, 5, primitiveMaxLength, arrayMaxLength), "; ").concat(error.stack || "");
}
